//export const api_url = "http://127.0.0.1:8000/api/user";
//export const api_url = "http://10.0.1.7:8000/api/user";
export const api_url = "https://play.uri.br/app/api/user";

export const time_to_reload_salas = 30000; //30 segundos